import React from 'react';
import './editor.scss';
import { PanelBody, PanelRow, TextControl, SelectControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import {
	useBlockProps,
	InspectorControls,
} from '@wordpress/block-editor';

export default function Edit( { attributes, setAttributes } ) {
	const { title, link, link_email, assembly, assembly_id } = attributes;

	const terms = useSelect((select) => {
		return select('core').getEntityRecords('taxonomy', 'assembly', { per_page: -1 });
	}, []);

	const termOptions = terms
    ? terms.map((term) => ({
        label: term.name,
        value: String(term.id),
        name: term.name,
      }))
    : [];

	const handleChange = (value) => {
		const selected = termOptions.find((term) => term.value === value);
		setAttributes({
			assembly_id: parseInt(value),
			assembly: selected ? selected.name : '',
		});
	};

	return (
		<div { ...useBlockProps() }>
			<InspectorControls key="setting">
				<PanelBody title="Configurações do Banner" initialOpen={true}>
					<PanelRow>
						<TextControl
							label="Título"
							placeholder='Título do Banner'
							value={title}
							onChange={(value) => setAttributes({ title: value })}
						/>
					</PanelRow>
					<PanelRow>
						<TextControl
							label="Link"
							placeholder='Link'
							value={link}
							onChange={(value) => setAttributes({ link: value })}
						/>
					</PanelRow>
					<PanelRow>
						<TextControl
							label="Link email"
							placeholder='Link email'
							value={link_email}
							onChange={(value) => setAttributes({ link_email: value })}
						/>
					</PanelRow>
					<PanelRow>
						<TextControl
							label="Assembleia"
							placeholder='Assembleia'
							value={assembly}
							onChange={(value) => setAttributes({ assembly: value })}
						/>
					</PanelRow>
					<PanelRow>
						<SelectControl
							label="Categoria do Evento"
							value={assembly_id ? String(assembly_id): ''}
							options={[{ label: 'Selecione...', value: '' }, ...termOptions]}
							onChange={handleChange}
						/>
					</PanelRow>															
				</PanelBody>
			</InspectorControls>
			<div>{title}</div>
			<div>{link}</div>
			<div>{link_email}</div>
			<div>{assembly}</div>
			<div>{assembly_id}</div>
		</div>
	);
}